import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;

if (!url || !key) {
  throw new Error('Faltan VITE_SUPABASE_URL o VITE_SUPABASE_PUBLISHABLE_KEY en .env');
}

export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// Tipo mínimo de producto público — antes de generar src/types/db.ts vía supabase CLI
export type ProductPublic = {
  id: string;
  sku: string;
  brand_code: string;
  name: string;
  short_description: string | null;
  description: string | null;
  msrp_mxn: number | null;
  msrp_usd: number | null;
  specs: Record<string, string>;
  images: { url: string; is_thumbnail: boolean; sort_order: number }[];
  tags: string[];
  status: 'active' | 'discontinued' | 'coming_soon' | 'out_of_stock';
  lutron_compatible: boolean;
  unit: string;
  legacy_lutron_line?: string | null;
  product_type?: string | null;
  category_paths?: string[] | null;
  meta_title?: string | null;
  meta_description?: string | null;
  warranty?: string | null;
  custom_fields?: Record<string, string> | null;
};
